import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'sy-divider',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class Divider {
  /**
   * Orientation options.
   */
  @Prop({ reflect: true }) type: 'default' | 'inset' | 'vertical' = 'default';

  render() {
    return <Host></Host>;
  }
}
